export const NAMESPACE_MENU = 'menu';

export const GET_MENU_DATA = 'getMenuData';
export const SAVE = 'save';
